export default __webpack_public_path__ + "static/media/emptyState.d1b7da1b.svg";